import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Col, Form, Skeleton, Row, Select, Typography, Space, Button, Flex } from 'antd';
import { getById, } from '../../../../apis/MovimientoEmpleadoApi';
import { getList as getPeriodos, getDetailsById as getDetailsByPeriodId } from '../../../../apis/PeriodosApi';
import { getEmpleadosActivos } from '../../../../apis/OdooApi';
import { getEncabezadoPreNomina, getDetallePreNomina } from '../../../../apis/ProcesoPreNominaApi';
import { getByConfiguration } from '../../../../apis/AcomuladoApi';
import Currency from '../../../../components/common/Currency';
import useCookies from "../../../../hooks/useCookies";
import _ from 'lodash';
const { Text, Link } = Typography;

const { Option } = Select;
const App = forwardRef(function AnioPeriodo({ onOk, onChangeEmpleado, onCancel, header, form, object, values, disabledForm, disabledSubmit = false }, ref) {
    const [empleadoCookie, setEmpleadoCookie] = useCookies("empleado_id");
    const [ID, setID] = useState(null);
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(disabledForm ?? false);
    const [initialValues, setInitialValues] = useState(values);
    const [empleados, setEmpleados] = useState([]);
    const [empleado, setEmpleado] = useState([]);
    const [tipoPeriodoSelected, setTiposPeriodoSelected] = useState([]);
    const [detailsPeriodo, setDetailsPeriodo] = useState([]);

    const [diasTrabajados, setDiasTrabajados] = useState(0);
    const [horasTrabajadas, setHorasTrabajadas] = useState(0);
    const [horasExtras, setHorasExtras] = useState(0);
    const [horasExtrasDobles, setHorasExtrasDobles] = useState(0);
    const [horasExtrasTriples, setHorasExtrasTriples] = useState(0);
    const [descanso, setDescanso] = useState(0);
    const [festivos, setFestivos] = useState(0);
    const [faltas, setFaltas] = useState(0);
    const [retardo, setRetardo] = useState(0);
    const [permisosConGoce, setPermisosConGoce] = useState(0);
    const [permisosSinGoce, setPermisosSinGoce] = useState(0);
    const [permisos, setPermisos] = useState(0);


    //1- Sustituir 2- Sumar 3- No Sustituir, Default 1
    const [clases, setClases] = useState([
        { value: "1", text: 'Sustituir' },
        { value: "2", text: 'Sumar' },
        { value: "3", text: 'No Sustituir' },
    ]);
    const conceptoRef = useRef(null);
    const effectRan = useRef(false);

    useEffect(() => {
        (async () => {
            if (!header) { return; }

            if (header?.periodo_id > 0) {
                await getEmpleadosOdoo();
            }

            // Preparar valores iniciales
            var _initialValues = { ...header };
            if (header?.period_id > 0) {
                _initialValues.period_id = header.period_id;
            }
            if (header?.num_periodo > 0) {
                _initialValues.num_periodo = header.num_periodo;
            }
            if (header?.anio > 0) {
                _initialValues.anio = header.anio;
            }

            // Determinar el empleado a cargar
            const empleadoId = header?.odoo_empleado_id || empleadoCookie?.value;
            if (empleadoId) {
                _initialValues.odoo_empleado_id = empleadoId;
            }

            form.setFieldsValue(_initialValues);
        })();
    }, [header?.periodo_id, header?.anio, header?.num_periodo]);

    useEffect(() => {
        (async () => {
            if (empleados.length === 0) return;
            if (!header) return;

            const empleadoId = header?.odoo_empleado_id || empleadoCookie?.value;

            const empleadoExiste = empleados.find(e => e.value === empleadoId);

            if (empleadoId && empleadoExiste) {
                await onChangeEmpleadoSelect(empleadoId);
            }
        })();
    }, [empleados.length]);

    useEffect(() => {
        (async () => {
            if (object?.id > 0) {
                setID(object.id);
                await refreshData(object.id);
            }
        })();
    }, [object]);

    useEffect(() => {
        (async () => {
            if (tipoPeriodoSelected?.value > 0) {
                await getDetailsPeriodo(tipoPeriodoSelected.value);
            }
        })();
    }, [tipoPeriodoSelected]);

    useEffect(() => {
        (async () => {
            setDisabled(disabledForm)
        })();
    }, [disabledForm]);

    useImperativeHandle(ref, () => ({
        updateEncabezado: (encabezado) => {
            console.log("updateEncabezado", encabezado);
            if (!encabezado) return;
            setDiasTrabajados(encabezado.dias_trabajados || 0);
            setHorasTrabajadas(encabezado.horas_trabajadas || 0);
            setHorasExtras(encabezado.horas_extras || 0);
            setHorasExtrasDobles(encabezado.horas_extras_dobles || 0);
            setHorasExtrasTriples(encabezado.horas_extras_triples || 0);
            setDescanso(encabezado.descanso || 0);
            setFestivos(encabezado.festivos || 0);
            setFaltas(encabezado.faltas || 0);
            setRetardo(encabezado.retardo || 0);
            setPermisosConGoce(encabezado.permisos_con_goce || 0);
            setPermisosSinGoce(encabezado.permisos_sin_goce || 0);
            setPermisos(encabezado.permisos || 0);
        }
    }));

    const refreshData = async (id) => {
        const response = await getById(id);
        if (response.ok) {
            let item = response.payload;
            setInitialValues(item);
            form.setFieldsValue(item);
        }
    }

    const getEmpleadosOdoo = async ()=>{
    const response = await getEmpleadosActivos({ nomina_need_timesheets: true });;
    if(response.ok){
        let items = response.payload;
        setEmpleados(items);
    }
}

    const getDetailsPeriodo = async (id) => {
        let detailsResponse = await getDetailsByPeriodId(id);
        if (detailsResponse.ok) {
            let item = detailsResponse.payload;
            setDetailsPeriodo(item);
        }
    }

    const onReset = () => {
        form.resetFields();
    };

    const onCancelBtn = async ({ }) => {
        if (onCancel) {
            await onCancel();
        }
    }

    const onFinish = async () => {
        setLoading(true);
        var values = form.getFieldsValue();
        await onOk(values)
        setLoading(false);
    }

    const onChangeEmpleadoSelect = async (value) => {
        const empleado = empleados.find(x => x.value == value)
        setEmpleado(empleado);
        setEmpleadoCookie(empleado);
        await onChangeEmpleado(value);

        let responseEncabezado = await getEncabezadoPreNomina(
            header?.periodo_id,
            header?.anio,
            header?.num_periodo,
            value
        );

        if (responseEncabezado.ok && responseEncabezado.payload) {
            let encabezado = responseEncabezado.payload;
            setDiasTrabajados(encabezado.dias_trabajados || 0);
            setHorasTrabajadas(encabezado.horas_trabajadas || 0);
            setHorasExtras(encabezado.horas_extras || 0);
            setHorasExtrasDobles(encabezado.horas_extras_dobles || 0);
            setHorasExtrasTriples(encabezado.horas_extras_triples || 0);
            setDescanso(encabezado.descanso || 0);
            setFestivos(encabezado.festivos || 0);
            setFaltas(encabezado.faltas || 0);
            setRetardo(encabezado.retardo || 0);
            setPermisosConGoce(encabezado.permisos_con_goce || 0);
            setPermisosSinGoce(encabezado.permisos_sin_goce || 0);
            setPermisos(encabezado.permisos || 0);
        } else {
            setDiasTrabajados(0);
            setHorasTrabajadas(0);
            setHorasExtras(0);
            setHorasExtrasDobles(0);
            setHorasExtrasTriples(0);
            setDescanso(0);
            setFestivos(0);
            setFaltas(0);
            setRetardo(0);
            setPermisosConGoce(0);
            setPermisosSinGoce(0);
            setPermisos(0);
        }
    }

    const filterOption = (input, option) => {
        return (option?.children ?? '').toLowerCase().includes(input.toLowerCase());
    };

    return (
        <>
            <Form disabled={disabled}
                layout="vertical"
                form={form}
                requiredMark
                autoComplete="off"
                onFinish={onFinish}>
                <Row gutter={16}>
                    <Col md={{ span: 8 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                        <Form.Item
                            name="odoo_empleado_id"
                            label="Empleado"
                            rules={[
                                {
                                    required: true,
                                    message: 'Selecciona un empleado',
                                },
                            ]}
                        >
                            <Select
                                placeholder="Por favor selecciona un empleado"
                                onChange={onChangeEmpleadoSelect}
                                showSearch
                                optionFilterProp="children"
                                filterOption={filterOption}
                                allowClear
                            >
                                {
                                    empleados.map((item) => <Option key={item.value} value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    {
                        empleado &&
                        <Col md={{ span: 16 }} sm={{ span: 16 }} xs={{ span: 24 }}>
                            <Row>
                                <Space size={'middle'}>
                                    <Text keyboard>Horario <b>{empleado.resource_calendar_name}</b></Text>
                                </Space>
                            </Row>
                           
                            <Row style={{ paddingTop: 10 }}>
                                <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                    Días Trabajados <br /><b>{diasTrabajados.toFixed(2)}</b>
                                </Col>
                                <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                    Horas Trabajadas <br /><b>{horasTrabajadas.toFixed(2)}</b>
                                </Col>
                                <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                    Horas Extras <br /><b>{horasExtras.toFixed(2)}</b>
                                </Col>
                                <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                    Faltas <br /><b>{faltas.toFixed(2)}</b>
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: 10 }}>
                                <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                    Extras Dobles <br /><b>{horasExtrasDobles.toFixed(2)}</b>
                                </Col>
                                <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                    Extras Triples <br /><b>{horasExtrasTriples.toFixed(2)}</b>
                                </Col>
                                <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                    Descanso Trabajado <br /><b>{descanso.toFixed(2)}</b>
                                </Col>
                                <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                    Festivo Trabajado <br /><b>{festivos.toFixed(2)}</b>
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: 10 }}>
                                <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                    Retardos <br /><b>{retardo.toFixed(2)}</b>
                                </Col>
                                <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                    Permiso c/Goce <br /><b>{permisosConGoce.toFixed(2)}</b>
                                </Col>
                                <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                    Permiso s/Goce <br /><b>{permisosSinGoce.toFixed(2)}</b>
                                </Col>
                                <Col md={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}></Col>
                            </Row>
                        </Col>
                    }
                </Row>
                <Form.Item>
                    <Space>
                        <Button type="primary" htmlType="submit" loading={loading} disabled={disabledSubmit}>
                            {loading ? 'Procesando' : 'Procesar'}
                        </Button>
                        <Button htmlType="button" onClick={onReset}>
                            Limpiar
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </>
    );
});

export default App;